import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import {
  QUERY_GET_CURRENT_SESSION_STATS,
  QUERY_GET_LIMITS,
} from "common/src/graphql/queries";
import { printAmount } from "common/src/helpers/functions";
import { useApolloClient } from "@apollo/client";
import {
  StyledModalBody,
  StyledModal,
  StyledModalFooter,
  AlertDanger,
  LinkWrapper,
  ModalClower,
  ModalLogoPLC,
  ModalLogoWrapper,
  ModalLogoABC,
  ModalLogoPUB,
  ModalLogoFUN,
} from "../styledComponents/StyledModals";
import { StyledButton } from "../styledComponents/CommonStyledComponents";

export const NlLogoutLimitDialog = ({
  showModal,
  player,
  server,
  grossResults,
  handleProceed,
  // pages,
  reachedLimit,
  skin,
}) => {
  const { t, i18n } = useTranslation("");
  const apolloClient = useApolloClient();

  const [allLimits, setAllLimits] = useState([]);
  const [nlDialogData, setNlDialogData] = useState({});
  const [currentSessionStats, setCurrentSessionStats] = useState([]);
  const baseUrl = `/${
    i18n.language || window.localStorage.i18nextLng || config.defaultLang
  }`;
  //console.log("period1 " + nlDialogData);

  useEffect(() => {
    async function getLimits() {
      const { loading, errors, data } = await apolloClient.query({
        query: QUERY_GET_LIMITS,
      });
      if (loading) return <h3>Loading ...</h3>;
      if (errors) return false;
      setAllLimits(data.getLimits.limits);
      return true;
    }

    const limitAmount = (timeRemaining) => {
      let sec_num = parseInt(timeRemaining, 10);
      let hours = Math.floor(sec_num / 3600);
      let minutes = Math.floor((sec_num - hours * 3600) / 60);
      let seconds = sec_num - hours * 3600 - minutes * 60;

      if (hours < 10) {
        hours = "0" + hours;
      }
      if (minutes < 10) {
        minutes = "0" + minutes;
      }
      if (seconds < 10) {
        seconds = "0" + seconds;
      }
      return hours + ":" + minutes;
    };

    function getDataForNlDialog() {
      let forNlDialog = {};
      allLimits.forEach((limit) => {
        if (limit.status === "active") {
          if (limit.limit === "timeout" && skin !== "plc") {
            forNlDialog[limit.limit + "_remaining"] =
              limitAmount(limit.remainingAmount) +
              (skin === "plc" ? " uur" : " hour(s)");
          } else if (limit.limit === "logincount") {
            forNlDialog[limit.limit + "_remaining"] = limit.remainingAmount;
          } else {
            forNlDialog[limit.limit + "_remaining"] = printAmount(
              limit.remainingAmount,
              player.currency,
              server.currencies,
              true
            );
          }
          if (limit.limitType === "daily_timelimit") {
            forNlDialog[limit.limit + "_remaining_daily"] =
              limitAmount(limit.remainingAmount) +
              (skin === "plc" ? " uur" : " hour(s)");
            forNlDialog[limit.limit + "_period_daily"] = limit.period;
          } else if (limit.limitType === "weekly_timelimit") {
            forNlDialog[limit.limit + "_remaining_weekly"] =
              limitAmount(limit.remainingAmount) +
              (skin === "plc" ? " uur" : " hour(s)");
            forNlDialog[limit.limit + "_period_weekly"] = limit.period;
          } else if (limit.limitType === "monthly_timelimit") {
            forNlDialog[limit.limit + "_remaining_monthly"] =
              limitAmount(limit.remainingAmount) +
              (skin === "plc" ? " uur" : " hour(s)");
            forNlDialog[limit.limit + "_period_monthly"] = limit.period;
          } else {
            forNlDialog[limit.limit + "_period"] = limit.period;
          }
        }
      });

      if (Object.keys(forNlDialog).length > 0) {
        forNlDialog["grossResults"] = printAmount(
          grossResults,
          player.currency,
          server.currencies,
          false
        );
        return forNlDialog;
      }
    }

    // console.log("limits dialog use effect " + JSON.stringify(player));
    // if (player && localStorage.getItem(NL_LIMIT_DIALOG)) {
    // console.log("GET LIMITS");
    if (allLimits.length === 0) {
      skin === "plc" && player && getLimits();
    }

    if (skin === "plc" && allLimits) {
      setNlDialogData(getDataForNlDialog);
    }
    // }
  }, [allLimits, player, apolloClient, grossResults, server.currencies]);

  useEffect(() => {
    async function getCurrentSessionStats() {
      const { loading, errors, data } = await apolloClient.query({
        query: QUERY_GET_CURRENT_SESSION_STATS,
      });
      if (loading) return <h3>Loading ...</h3>;
      if (errors) return false;
      // console.log(data);
      setCurrentSessionStats(data.getCurrentSessionStats);
      return true;
    }
    // console.log(pages["deposit"]);
    // console.log(location);
    // if(pages["deposit"] && location.pathname !== pages["deposit"]) {
    skin === "plc" && player && getCurrentSessionStats();
    // }
  }, [currentSessionStats, player, apolloClient]);

  // function cancelNlLimitDialog() {
  //   setNlLimitDialog(false);
  //   localStorage.setItem(NL_LIMIT_DIALOG, false);
  // }
  //console.log("nl limts show model: " + JSON.stringify(showModel));
  return (
    <StyledModal isOpen={showModal}>
      {skin === "plc" && <ModalClower />}
      {skin === "plc" &&
      nlDialogData &&
      Object.keys(nlDialogData).length > 0 ? (
        <StyledModalBody position>
          <h2
            dangerouslySetInnerHTML={{
              __html: t("label_nl_limits_title", {
                firstname: player.firstName,
              }),
            }}
          ></h2>
          <AlertDanger danger={reachedLimit === "deposit"}>
            <span
              dangerouslySetInnerHTML={{ __html: t("label_nl_limits_deposit") }}
            ></span>
            :{" "}
            {nlDialogData.deposit_remaining ? (
              <>
                {nlDialogData.deposit_remaining} -{" "}
                <span
                  dangerouslySetInnerHTML={{
                    __html: t("label_" + nlDialogData.deposit_period),
                  }}
                ></span>
              </>
            ) : (
              <span
                dangerouslySetInnerHTML={{
                  __html: t("label_nl_limits_not_set"),
                }}
              ></span>
            )}
          </AlertDanger>
          <AlertDanger danger={reachedLimit === "loss"}>
            <span
              dangerouslySetInnerHTML={{ __html: t("label_nl_limits_loss") }}
            ></span>
            :{" "}
            {nlDialogData.loss_remaining ? (
              <>
                {nlDialogData.loss_remaining} -{" "}
                <span
                  dangerouslySetInnerHTML={{
                    __html: t("label_" + nlDialogData.loss_period),
                  }}
                ></span>
              </>
            ) : (
              <span
                dangerouslySetInnerHTML={{
                  __html: t("label_nl_limits_not_set"),
                }}
              ></span>
            )}
          </AlertDanger>
          <AlertDanger danger={reachedLimit === "bet"}>
            <span
              dangerouslySetInnerHTML={{ __html: t("label_nl_limits_bet") }}
            ></span>
            :{" "}
            {nlDialogData.bet_remaining && (
              <>
                {" "}
                {nlDialogData.bet_remaining} -{" "}
                <span
                  dangerouslySetInnerHTML={{
                    __html: t("label_" + nlDialogData.bet_period),
                  }}
                ></span>
              </>
            )}
          </AlertDanger>
          {skin !== "plc" && (
            <AlertDanger danger={reachedLimit === "session"}>
              <span
                dangerouslySetInnerHTML={{
                  __html: t("label_nl_limits_session"),
                }}
              ></span>
              : {nlDialogData.timeout_remaining}
            </AlertDanger>
          )}
          <AlertDanger danger={reachedLimit === "maxbalance"}>
            {/* new ones */}
            <span
              dangerouslySetInnerHTML={{
                __html: t("label_nl_limits_maxbalance"),
              }}
            ></span>
            : {nlDialogData.limit_remaining}
          </AlertDanger>
          <AlertDanger danger={reachedLimit === "logincount"}>
            <span
              dangerouslySetInnerHTML={{
                __html: t("label_nl_limits_logincount"),
              }}
            ></span>
            :{" "}
            {nlDialogData.logincount_remaining ? (
              <>
                {" "}
                {nlDialogData.logincount_remaining}x{" "}
                <span
                  dangerouslySetInnerHTML={{
                    __html: t("label_" + nlDialogData.logincount_period),
                  }}
                ></span>
              </>
            ) : (
              <span
                dangerouslySetInnerHTML={{
                  __html: t("label_nl_limits_not_set"),
                }}
              ></span>
            )}
          </AlertDanger>
          <AlertDanger danger={reachedLimit === "daily"}>
            <span
              dangerouslySetInnerHTML={{
                __html: t("label_nl_limits_timelimit_daily"),
              }}
            ></span>
            :{" "}
            {nlDialogData.timelimit_remaining_daily ? (
              <>
                {" "}
                {nlDialogData.timelimit_remaining_daily} -{" "}
                <span
                  dangerouslySetInnerHTML={{
                    __html: t("label_" + nlDialogData.timelimit_period_daily),
                  }}
                ></span>
              </>
            ) : (
              <span
                dangerouslySetInnerHTML={{
                  __html: t("label_nl_limits_not_set"),
                }}
              ></span>
            )}
          </AlertDanger>
          <AlertDanger danger={reachedLimit === "weekly"}>
            <span
              dangerouslySetInnerHTML={{
                __html: t("label_nl_limits_timelimit_weekly"),
              }}
            ></span>
            :{" "}
            {nlDialogData.timelimit_remaining_weekly ? (
              <>
                {" "}
                {nlDialogData.timelimit_remaining_weekly} -{" "}
                <span
                  dangerouslySetInnerHTML={{
                    __html: t("label_" + nlDialogData.timelimit_period_weekly),
                  }}
                ></span>
              </>
            ) : (
              <span
                dangerouslySetInnerHTML={{
                  __html: t("label_nl_limits_not_set"),
                }}
              ></span>
            )}
          </AlertDanger>
          <AlertDanger danger={reachedLimit === "monthly"}>
            <span
              dangerouslySetInnerHTML={{
                __html: t("label_nl_limits_timelimit_monthly"),
              }}
            ></span>
            :{" "}
            {nlDialogData.timelimit_remaining_monthly ? (
              <>
                {" "}
                {nlDialogData.timelimit_remaining_monthly} -{" "}
                <span
                  dangerouslySetInnerHTML={{
                    __html: t("label_" + nlDialogData.timelimit_period_monthly),
                  }}
                ></span>
              </>
            ) : (
              <span
                dangerouslySetInnerHTML={{
                  __html: t("label_nl_limits_not_set"),
                }}
              ></span>
            )}
          </AlertDanger>
          <div>
            <span
              dangerouslySetInnerHTML={{ __html: t("label_nl_limits_result") }}
            ></span>
            : {nlDialogData.grossResults}
          </div>
          <StyledModalBody>
            <span
              dangerouslySetInnerHTML={{
                __html: t("balance_upon_login"),
              }}
            ></span>
            :{" "}
            <span>
              {currentSessionStats &&
                printAmount(
                  currentSessionStats.initialBalance,
                  player.currency,
                  server.currencies,
                  false
                )}
            </span>
            <br />
            <span
              dangerouslySetInnerHTML={{
                __html: t("total_wagers_since_last_login"),
              }}
            ></span>
            :{" "}
            <span>
              {currentSessionStats &&
                printAmount(
                  currentSessionStats.bet,
                  player.currency,
                  server.currencies,
                  false
                )}
            </span>
            <br />
            <span
              dangerouslySetInnerHTML={{
                __html: t("total_wins_loss_since_last_login"),
              }}
            ></span>
            :{" "}
            <span>
              {currentSessionStats &&
                printAmount(
                  currentSessionStats.gross,
                  player.currency,
                  server.currencies,
                  false
                )}
            </span>
          </StyledModalBody>
          <LinkWrapper>
            <span
              dangerouslySetInnerHTML={{
                __html: t("label_nl_responsible_gaming_link", {
                  link: `${baseUrl}/responsible-gaming`,
                }),
              }}
            ></span>
          </LinkWrapper>
        </StyledModalBody>
      ) : (
        <>
          {skin === "plc" && <ModalClower bottomright="true" />}
          <ModalLogoWrapper>
            {skin === "plc" && <ModalLogoPLC />}
            {skin === "abc" && <ModalLogoABC />}
            {skin === "pub" && <ModalLogoPUB />}
            {skin === "fun" && <ModalLogoFUN />}
          </ModalLogoWrapper>
          <StyledModalBody register>
            {t("force_logout_message")}
          </StyledModalBody>
        </>
      )}
      <StyledModalFooter position>
        <StyledButton
          banktransfer
          pub={skin === "pub"}
          onClick={() => handleProceed()}
        >
          {t("label_ok")}
        </StyledButton>
      </StyledModalFooter>
      {skin === "plc" && <ModalClower bottomright="true" />}
    </StyledModal>
  );
};
